import React from 'react';

function LandingPage({ showChat }) {
  return (
    <div className="landing-content">
      <h1>Discover Your Perfect Movie with AI-Powered Recommendations</h1>
      <h2>Your Personalized Movie Guide</h2>
      
      <section className="intro-section">
        <p className="hero-text">
          Welcome to AI Movie Recommendation, the ultimate intelligent movie finder that helps you discover films perfectly matched to your preferences. Our advanced artificial intelligence analyzes thousands of movies to suggest personalized recommendations tailored just for you.
        </p>
        <button className="start-btn" onClick={showChat}>Chat with AI</button>
      </section>

      <div className="features-grid">
        <div className="feature-card">
          <h3>How It Works</h3>
          <p>Simply tell our AI assistant what kind of movie you're in the mood for. Whether you're looking for action films directed by Christopher Nolan, romantic comedies from the 90s, or the latest horror thrillers, our smart recommendation system instantly finds the perfect movies for your evening.</p>
        </div>

        <div className="feature-card">
          <h3>Key Features</h3>
          <ul>
            <li>Personalized Movie Suggestions</li>
            <li>Intelligent Film Recommendations</li>
            <li>Search by Actor, Director, Genre, or Time Period</li>
            <li>High-Quality Movie Finder</li>
            <li>Smart Film Matching</li>
          </ul>
        </div>

        <div className="feature-card">
          <h3>Why Choose Our AI Movie Recommender</h3>
          <p>Finding the perfect film shouldn't be complicated. Our movie suggestion tool eliminates endless scrolling through streaming platforms and helps you discover hidden gems and blockbusters that match exactly what you want to watch today.</p>
        </div>
      </div>

      <div className="cta-section">
        <h3>Explore Movies Now</h3>
        <p>Try our AI-powered recommendation system now and transform how you discover movies. Get started with personalized suggestions based on your preferences and rediscover the joy of finding the perfect film.</p>
      </div>
    </div>
  );
}

export default LandingPage;
